export const createLatLng = (latitude: number, longitude: number) => {
  return new naver.maps.LatLng(latitude, longitude);
};
